// export const WeatherTitleIcon = () => (
// 	<svg
// 		xmlns="http://www.w3.org/2000/svg"
// 		width={ 20 }
// 		height={ 26 }
// 		fill="none"
// 	>
// 		<path fill="none" d="M0 2a2 2 0 0 1 2-2h18v26H2a2 2 0 0 1-2-2V2Z" />
// 		<path
// 			fill="#4B4744"
// 			d="M8.964 8.822a1.22 1.22 0 1 1-2.44 0 1.22 1.22 0 0 1 2.44 0Z"
// 		/>
// 		<path
// 			fill="#4B4744"
// 			d="M8.847 8.822c-.004.456-.29.881-.724 1.036-.44.157-.93.021-1.23-.336a1.11 1.11 0 0 1-.09-1.274 1.11 1.11 0 0 1 1.152-.509c.515.104.888.56.892 1.083.001.151.236.151.234 0a1.355 1.355 0 0 0-.88-1.257 1.343 1.343 0 0 0-1.483.403 1.35 1.35 0 0 0-.116 1.547c.293.481.866.726 1.416.616a1.352 1.352 0 0 0 1.065-1.309c0-.151-.235-.151-.236 0ZM8.964 13a1.22 1.22 0 1 1-2.44 0 1.22 1.22 0 0 1 2.44 0Z"
// 		/>
// 		<path
// 			fill="#4B4744"
// 			d="M8.847 13c-.004.456-.29.881-.724 1.036-.44.157-.93.02-1.23-.337a1.11 1.11 0 0 1-.09-1.274 1.11 1.11 0 0 1 1.152-.508c.515.104.888.559.892 1.083.001.15.236.15.234 0a1.354 1.354 0 0 0-.88-1.258 1.343 1.343 0 0 0-1.483.403 1.35 1.35 0 0 0-.116 1.547c.293.482.866.727 1.416.617a1.352 1.352 0 0 0 1.065-1.31c0-.15-.235-.15-.236 0ZM8.964 17.178a1.22 1.22 0 1 1-2.44 0 1.22 1.22 0 0 1 2.44 0Z"
// 		/>
// 		<path
// 			fill="#4B4744"
// 			d="M8.847 17.177c-.004.456-.29.882-.724 1.036-.44.157-.93.021-1.23-.336a1.11 1.11 0 0 1-.09-1.274 1.11 1.11 0 0 1 1.152-.508c.515.104.888.559.892 1.082.001.152.236.152.234 0a1.355 1.355 0 0 0-.88-1.257 1.343 1.343 0 0 0-1.483.403 1.35 1.35 0 0 0-.116 1.547c.293.482.866.727 1.416.616a1.352 1.352 0 0 0 1.065-1.309c0-.15-.235-.15-.236 0ZM13.476 8.822a1.22 1.22 0 1 1-2.44 0 1.22 1.22 0 0 1 2.44 0Z"
// 		/>
// 		<path
// 			fill="#4B4744"
// 			d="M13.359 8.822c-.004.456-.291.881-.725 1.036-.439.157-.93.021-1.23-.336a1.11 1.11 0 0 1-.09-1.274 1.11 1.11 0 0 1 1.153-.509c.514.104.888.56.892 1.083 0 .151.235.151.234 0a1.354 1.354 0 0 0-.881-1.257 1.343 1.343 0 0 0-1.483.403 1.35 1.35 0 0 0-.116 1.547c.293.481.866.726 1.417.616a1.352 1.352 0 0 0 1.064-1.309c0-.151-.234-.151-.235 0ZM13.476 13a1.22 1.22 0 1 1-2.44 0 1.22 1.22 0 0 1 2.44 0Z"
// 		/>
// 		<path
// 			fill="#4B4744"
// 			d="M13.359 13c-.004.456-.291.881-.725 1.036-.439.157-.93.02-1.23-.337a1.11 1.11 0 0 1-.09-1.274 1.11 1.11 0 0 1 1.153-.508c.514.104.888.559.892 1.083 0 .15.235.15.234 0a1.354 1.354 0 0 0-.881-1.258 1.343 1.343 0 0 0-1.483.403 1.35 1.35 0 0 0-.116 1.547c.293.482.866.727 1.417.617a1.352 1.352 0 0 0 1.064-1.31c0-.15-.234-.15-.235 0ZM13.476 17.178a1.22 1.22 0 1 1-2.44 0 1.22 1.22 0 0 1 2.44 0Z"
// 		/>
// 		<path
// 			fill="#4B4744"
// 			d="M13.359 17.177c-.004.456-.291.882-.725 1.036-.439.157-.93.021-1.23-.336a1.11 1.11 0 0 1-.09-1.274 1.11 1.11 0 0 1 1.153-.508c.514.104.888.559.892 1.082 0 .152.235.152.234 0a1.355 1.355 0 0 0-.881-1.257 1.343 1.343 0 0 0-1.483.403 1.35 1.35 0 0 0-.116 1.547c.293.482.866.727 1.417.616a1.352 1.352 0 0 0 1.064-1.309c0-.15-.234-.15-.235 0Z"
// 		/>
// 	</svg>
// );

// panel body icon
export const LayoutIcon = () => {
	return (
		<div className="sp-location-weather-panelbody-icon">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={ 16 }
				height={ 16 }
				fill="none"
			>
				<g fill="#1E1E1E" clipPath="url(#a)">
					<path d="M1.96 15.5h4.062c.806 0 1.46-.655 1.46-1.46V1.96c0-.805-.655-1.46-1.46-1.46H1.96C1.155.5.5 1.155.5 1.96V14.04c0 .805.655 1.46 1.46 1.46ZM1.74 1.96c0-.122.1-.221.221-.221h4.062c.122 0 .222.1.222.221V14.04c0 .122-.1.222-.222.222H1.96a.222.222 0 0 1-.221-.221V1.96ZM13.929.501h-3.83c-.865 0-1.57.705-1.57 1.572v3.829c0 .866.704 1.571 1.57 1.571h3.83c.866 0 1.571-.704 1.571-1.571v-3.83c0-.866-.705-1.57-1.571-1.57Zm.333 5.4c0 .185-.15.333-.333.333h-3.83a.333.333 0 0 1-.332-.333V2.072c0-.184.15-.333.333-.333h3.829c.184 0 .333.15.333.333v3.83ZM13.929 8.529h-3.83c-.865 0-1.57.704-1.57 1.571v3.83c0 .866.704 1.57 1.57 1.57h3.83c.866 0 1.571-.704 1.571-1.57V10.1c0-.866-.705-1.571-1.571-1.571Zm.333 5.4c0 .184-.15.333-.333.333h-3.83a.333.333 0 0 1-.332-.333V10.1c0-.184.15-.333.333-.333h3.829c.184 0 .333.15.333.333v3.83Z" />
				</g>
				<defs>
					<clipPath id="a">
						<path fill="#fff" d="M0 0h16v16H0z" />
					</clipPath>
				</defs>
			</svg>
		</div>
	);
};

export const BasicPreferencesStylesIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
	>
		<g fill="#1E1E1E" clipPath="url(#a)">
			<path d="M14.831 7.625a.522.522 0 0 0-.531.51 6.61 6.61 0 0 1-.247 1.656h-3.297c.047-.532.072-1.082.075-1.647a.522.522 0 0 0-.516-.525h-.003a.524.524 0 0 0-.522.515 18.772 18.772 0 0 1-.08 1.654H6.283a19.525 19.525 0 0 1-.081-1.794c0-.619.028-1.219.081-1.794h2.34a.523.523 0 0 0 0-1.044H6.416c.11-.68.257-1.306.441-1.847.275-.806.734-1.621 1.144-1.621.187 0 .375.009.562.025a.52.52 0 0 0 .563-.475.52.52 0 0 0-.475-.563A7.536 7.536 0 0 0 8 .647C3.884.647.66 3.872.66 7.991s3.209 7.328 7.312 7.344H8c1.965 0 3.8-.738 5.165-2.076 1.363-1.337 2.138-3.153 2.179-5.112a.52.52 0 0 0-.51-.531l-.003.01Zm-5.247 3.21a10.62 10.62 0 0 1-.456 1.89c-.406 1.166-.863 1.578-1.128 1.578-.406 0-.869-.815-1.144-1.622a11.375 11.375 0 0 1-.44-1.846h3.168Zm-4.34-1.041h-3.3A6.56 6.56 0 0 1 1.697 8c0-.619.084-1.219.247-1.794h3.3a20.836 20.836 0 0 0 0 3.588ZM3.519 3.519A6.2 6.2 0 0 1 6.34 1.906a6.556 6.556 0 0 0-.468 1.075 12.365 12.365 0 0 0-.507 2.185H2.344a6.148 6.148 0 0 1 1.175-1.647Zm-1.175 7.316h3.021c.12.806.291 1.546.507 2.184.147.431.303.784.465 1.075a6.201 6.201 0 0 1-2.818-1.61 6.081 6.081 0 0 1-1.175-1.646v-.003Zm10.093 1.69a6.167 6.167 0 0 1-2.775 1.566c.185-.332.335-.688.45-1.025.225-.647.403-1.407.525-2.235h3.022a6.168 6.168 0 0 1-1.219 1.691l-.003.003Z" />
			<path d="M12.081 7.834a.519.519 0 0 0 .856 0l1.91-2.756a2.769 2.769 0 0 0 .497-1.587A2.838 2.838 0 0 0 12.509.656a2.838 2.838 0 0 0-2.834 2.835c0 1.562.172 1.118.497 1.587l1.91 2.756Zm.428-6.137c.988 0 1.794.803 1.794 1.794 0 .99-.106.7-.31.993l-1.48 2.141-1.482-2.14a1.738 1.738 0 0 1-.31-.994c0-.988.804-1.794 1.794-1.794h-.006Z" />
			<path d="M12.437 4.206h.753a.461.461 0 1 0 0-.925h-.29V2.76a.461.461 0 1 0-.925 0v.985c0 .256.206.462.462.462Z" />
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h16v16H0z" />
			</clipPath>
		</defs>
	</svg>
);

export const CurrentWeatherStylesIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
	>
		<g clipPath="url(#a)">
			<path
				fill="#1E1E1E"
				d="M5.84 16a.649.649 0 0 1-.405-.135.56.56 0 0 1-.17-.405c0-.169.068-.304.17-.405L7.089 13.4s.1-.101.033-.203c-.067-.101-.168-.101-.168-.101H5.806c-.101 0-.203 0-.304-.101a.454.454 0 0 1-.202-.237c-.034-.1-.068-.202 0-.337 0-.101.067-.203.168-.27l2.87-2.87a.542.542 0 0 1 .37-.168c.136 0 .305.067.406.169a.559.559 0 0 1 .169.405c0 .169-.068.27-.169.405L7.46 11.747s-.068.101-.034.202c.034.102.169.068.169.068h1.148c.1 0 .202 0 .303.101a.454.454 0 0 1 .203.236c.034.102.067.203 0 .338 0 .101-.068.203-.169.27l-2.869 2.87A.542.542 0 0 1 5.84 16Zm8.641-9.114a.623.623 0 0 1-.405-.169.559.559 0 0 1-.169-.405c0-.169.068-.304.169-.405a.56.56 0 0 1 .405-.169h.709c.135 0 .304.068.405.17a.56.56 0 0 1 .169.404.56.56 0 0 1-.169.405.56.56 0 0 1-.405.17h-.709ZM5.873 3.342c-.067 0-.135 0-.202-.034-.068-.034-.135-.067-.169-.135l-.506-.506a.593.593 0 0 1-.135-.17c0-.067-.034-.134-.034-.202 0-.067 0-.135.034-.202 0-.068.067-.135.135-.169a.593.593 0 0 1 .169-.135h.438c.102 0 .135.068.17.135l.506.506c.067.068.1.102.135.17 0 .067.033.134.033.202 0 .067 0 .135-.033.202 0 .068-.068.135-.135.169-.068.068-.102.101-.17.135-.067 0-.134.034-.202.034h-.034Zm7.123-.034c-.101 0-.203 0-.304-.101a.454.454 0 0 1-.203-.237c-.033-.1-.067-.202 0-.337 0-.101.068-.203.17-.27l.506-.506a.593.593 0 0 1 .168-.135h.405c.068 0 .136.067.17.135.033.067.1.1.134.168v.405c0 .068-.067.135-.135.17l-.506.505a.56.56 0 0 1-.405.17v.033ZM9.452 1.857a.623.623 0 0 1-.406-.17.559.559 0 0 1-.168-.404v-.71c0-.134.067-.303.168-.404A.559.559 0 0 1 9.452 0c.168 0 .303.068.405.169a.559.559 0 0 1 .168.405v.709a.623.623 0 0 1-.168.405.559.559 0 0 1-.405.169Zm4.658 7.156a2.987 2.987 0 0 0-1.283-1.52l-.101-.067v-.135c.135-.304.169-.641.169-.945 0-.81-.27-1.587-.81-2.194a3.469 3.469 0 0 0-2.026-1.182c-.202-.033-.405-.067-.607-.067-.608 0-1.182.169-1.722.473a3.424 3.424 0 0 0-1.519 1.789v.067H6.11a3.852 3.852 0 0 0-2.127 1.722l-.067.1h-.102a1.976 1.976 0 0 0-.438-.067c-.844 0-1.62.338-2.228.912a3.085 3.085 0 0 0-.912 2.228c0 .843.338 1.62.912 2.227a3.085 3.085 0 0 0 2.228.912c.067 0 .303-.068.405-.169a.559.559 0 0 0 .168-.405.56.56 0 0 0-.168-.405.56.56 0 0 0-.405-.169c-.54 0-1.047-.202-1.452-.607a2.017 2.017 0 0 1-.607-1.452c0-.54.202-1.046.607-1.451A2.1 2.1 0 0 1 3.376 8c.54 0 .472.034.675.135h.168c.034 0 .17 0 .237-.034a.48.48 0 0 0 .27-.304c.202-.506.54-.945.979-1.248a2.695 2.695 0 0 1 1.519-.473c.54 0 1.08.169 1.519.473.438.303.776.742.979 1.248a.662.662 0 0 0 .303.304.625.625 0 0 0 .237.068h.168c.203-.068.44-.135.675-.135h.304c.507.067.98.337 1.283.742.304.405.473.912.439 1.418 0 .506-.27.979-.642 1.35-.37.338-.877.54-1.384.54-.305.034-.303.068-.405.17a.559.559 0 0 0-.168.404c0 .169.067.304.168.405a.559.559 0 0 0 .405.17 3.19 3.19 0 0 0 1.89-.642c.54-.405.946-1.013 1.149-1.654a3.122 3.122 0 0 0 0-1.924h-.034Zm-2.43-2.06v.034c0 .034-.136 0-.136 0h-.911l-.068-.067a3.812 3.812 0 0 0-1.181-1.25 3.515 3.515 0 0 0-1.62-.607s-.135 0-.169-.067c-.034-.068.067-.169.067-.169.203-.27.507-.473.81-.608.304-.135.642-.202.98-.202.607 0 1.215.236 1.653.675.44.439.676 1.013.676 1.654s0 .371-.068.574l-.034.034Z"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h16v16H0z" />
			</clipPath>
		</defs>
	</svg>
);

export const AdditionalDataStylesIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
	>
		<g clipPath="url(#a)">
			<path
				fill="#1E1E1E"
				d="M15.304 9.187c0 2.166-1.797 3.929-4.005 3.929H3.2c-1.759 0-3.19-1.404-3.19-3.13 0-.795.305-1.553.857-2.134a3.201 3.201 0 0 1 1.932-.973c.07-2.308 2.006-4.166 4.377-4.166a4.415 4.415 0 0 1 3.948 2.44l.032.067c.003.01.004.023.004.035a.176.176 0 0 1-.02.078l-.064.063-.019.017-.788.788a.099.099 0 0 1-.165-.04V6.16C9.72 4.912 8.515 4.04 7.175 4.04c-1.684 0-3.053 1.332-3.053 2.97 0 .143.012.289.032.431a.666.666 0 0 1-.18.558.667.667 0 0 1-.554.194 2.059 2.059 0 0 0-.222-.016c-1.028 0-1.863.811-1.863 1.806 0 .994.836 1.802 1.864 1.802h8.12c1.47-.01 2.661-1.173 2.661-2.602 0-.368-.078-.718-.22-1.035a.1.1 0 0 1 .02-.112l.076-.077.722-.722.033-.033a.1.1 0 0 1 .157.02 3.85 3.85 0 0 1 .536 1.963Z"
			/>
			<path
				fill="#1E1E1E"
				d="M11.727 8.53a1.18 1.18 0 0 0-2.36 0v.002c0 .872-.474 1.633-1.18 2.041l.005.004a2.36 2.36 0 0 0 3.536-2.048ZM10.146 11.787a3.363 3.363 0 0 1-1.552 0h1.552ZM15.734 3.41a.904.904 0 0 0-1.278 0l-3.242 3.24a.157.157 0 0 0 .05.257c.44.182.79.533.973.973a.157.157 0 0 0 .256.05l3.241-3.242a.904.904 0 0 0 0-1.279Z"
			/>
			<path
				stroke="#1E1E1E"
				strokeLinecap="round"
				strokeMiterlimit={ 10 }
				strokeWidth={ 0.88 }
				d="M5.52 7.055c0-.095.009-.888.648-1.374.56-.426 1.377-.438 2.02-.013"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h16v16H0z" />
			</clipPath>
		</defs>
	</svg>
);

export const WeatherForecastDataStylesIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
	>
		<path
			fill="#1E1E1E"
			d="M9.667 15.034c-.167 0-.367-.034-.533-.1-.3-.134-.567-.4-.667-.7L6.667 9.5s-.1-.166-.333-.2C6.1 9.267 6 9.467 6 9.467L5.2 11.2c-.1.234-.266.4-.466.534-.2.133-.434.2-.7.2H1.4c-.2 0-.4-.1-.5-.3-.1-.167-.1-.4 0-.567.1-.167.3-.3.5-.3h2.7l1.067-2.333c.133-.3.4-.567.733-.667.134-.067.3-.067.467-.067.167 0 .367.034.533.1.3.134.567.4.667.734L9.4 13.267s.1.167.334.167c.233 0 .333-.167.333-.167l.8-1.733c.1-.234.266-.4.466-.534.2-.133.434-.2.7-.2h2.634c.2 0 .4.1.5.3.1.167.1.4 0 .567-.1.167-.3.3-.5.3h-2.7L10.9 14.3c-.133.3-.4.567-.733.667-.133.066-.3.1-.467.1l-.033-.034Z"
		/>
		<path
			fill="#1E1E1E"
			d="M15.038 8.93h-.142c-.177-.036-.283-.142-.39-.284a.708.708 0 0 1-.07-.46c.177-.744 0-1.522-.46-2.124a2.366 2.366 0 0 0-1.84-.885h-.142a.532.532 0 0 1-.39-.142c-.106-.07-.177-.212-.212-.318a3.335 3.335 0 0 0-1.84-2.23 3.463 3.463 0 0 0-2.904 0 3.335 3.335 0 0 0-1.84 2.23c0 .141-.106.248-.213.318a.742.742 0 0 1-.389.142h-.07c-.532 0-1.098.177-1.523.531a2.35 2.35 0 0 0-.885 1.38c-.07.39-.07.744 0 1.098.07.212 0 .425-.177.602a.653.653 0 0 1-.425.177H.95C.737 8.894.56 8.752.525 8.54A3.762 3.762 0 0 1 .56 6.558c.212-.638.566-1.24 1.097-1.664a3.815 3.815 0 0 1 1.806-.814h.212l.07-.248a4.482 4.482 0 0 1 2.479-2.478A4.392 4.392 0 0 1 7.994 1c.601 0 1.203.106 1.77.354a4.482 4.482 0 0 1 2.477 2.478s.036.106.107.177c.07.07.177.07.177.07.672.107 1.31.39 1.805.815.53.425.885 1.026 1.097 1.664.213.637.213 1.345.036 1.982 0 .141-.107.248-.213.318a.742.742 0 0 1-.39.142l.178-.07Z"
		/>
	</svg>
);

export const FooterStylesIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
	>
		<g fill="#1E1E1E" clipPath="url(#a)">
			<path d="M3.472 16C1.838 16 .51 14.76.51 13.238V2.761C.51 1.241 1.84 0 3.472 0h9.053c1.635 0 2.963 1.24 2.963 2.763v10.471c0 1.525-1.328 2.763-2.963 2.763H3.472V16Zm0-14.906c-.975 0-1.768.75-1.768 1.672v10.472c0 .921.793 1.671 1.768 1.671h9.053c.975 0 1.77-.75 1.77-1.671V2.761c0-.921-.795-1.671-1.77-1.671H3.472v.003Z" />
			<path d="M4.134 12.987c-.328 0-.597-.243-.597-.547 0-.303.269-.546.597-.546h7.734c.329 0 .597.243.597.546 0 .304-.268.547-.597.547H4.134Z" />
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h16v16H0z" />
			</clipPath>
		</defs>
	</svg>
);

export const DisplayStyleIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
	>
		<g fill="#1E1E1E" clipPath="url(#a)">
			<path d="M15.5 15a.5.5 0 0 1-.5.5H9.346a.5.5 0 0 1-.5-.5V9.346a.5.5 0 0 1 .5-.5H15a.5.5 0 0 1 .5.5V15Zm-5.369-1.286a.5.5 0 0 0 .5.5h3.083a.5.5 0 0 0 .5-.5v-3.082a.5.5 0 0 0-.5-.5h-3.083a.5.5 0 0 0-.5.5v3.082ZM7.154 15a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V9.346a.5.5 0 0 1 .5-.5h5.654a.5.5 0 0 1 .5.5V15Zm-5.368-1.286a.5.5 0 0 0 .5.5h3.082a.5.5 0 0 0 .5-.5v-3.082a.5.5 0 0 0-.5-.5H2.286a.5.5 0 0 0-.5.5v3.082ZM15.5 6.654a.5.5 0 0 1-.5.5H9.346a.5.5 0 0 1-.5-.5V1a.5.5 0 0 1 .5-.5H15a.5.5 0 0 1 .5.5v5.654ZM10.13 5.368a.5.5 0 0 0 .5.5h3.083a.5.5 0 0 0 .5-.5V2.286a.5.5 0 0 0-.5-.5h-3.083a.5.5 0 0 0-.5.5v3.082ZM7.154 6.654a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V1A.5.5 0 0 1 1 .5h5.654a.5.5 0 0 1 .5.5v5.654ZM1.786 5.368a.5.5 0 0 0 .5.5h3.082a.5.5 0 0 0 .5-.5V2.286a.5.5 0 0 0-.5-.5H2.286a.5.5 0 0 0-.5.5v3.082Z" />
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h16v16H0z" />
			</clipPath>
		</defs>
	</svg>
);

export const WeatherLayoutIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
	>
		<g fill="#1E1E1E" clipPath="url(#a)">
			<path d="M1.96 15.5h4.062c.806 0 1.46-.655 1.46-1.46V1.96c0-.805-.655-1.46-1.46-1.46H1.96C1.155.5.5 1.155.5 1.96V14.04c0 .805.655 1.46 1.46 1.46ZM1.74 1.96c0-.122.1-.221.221-.221h4.062c.122 0 .222.1.222.221V14.04c0 .122-.1.222-.222.222H1.96a.222.222 0 0 1-.221-.221V1.96ZM13.929.501h-3.83c-.865 0-1.57.705-1.57 1.572v3.829c0 .866.704 1.571 1.57 1.571h3.83c.866 0 1.571-.704 1.571-1.571v-3.83c0-.866-.705-1.57-1.571-1.57Zm.333 5.4c0 .185-.15.333-.333.333h-3.83a.333.333 0 0 1-.332-.333V2.072c0-.184.15-.333.333-.333h3.829c.184 0 .333.15.333.333v3.83ZM13.929 8.529h-3.83c-.865 0-1.57.704-1.57 1.571v3.83c0 .866.704 1.57 1.57 1.57h3.83c.866 0 1.571-.704 1.571-1.57V10.1c0-.866-.705-1.571-1.571-1.571Zm.333 5.4c0 .184-.15.333-.333.333h-3.83a.333.333 0 0 1-.332-.333V10.1c0-.184.15-.333.333-.333h3.829c.184 0 .333.15.333.333v3.83Z" />
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h16v16H0z" />
			</clipPath>
		</defs>
	</svg>
);

export const TemplatePresetIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
	>
		<path
			fill="#1E1E1E"
			d="M3.7 12.733a1.373 1.373 0 0 1-1.367-1.366c0-.734.267-.967.7-1.2v-.034C3.1 9.3 3.8 8.6 4.667 8.5h.3c.533 0 1.066.233 1.4.6h.266c.634 0 1.2.433 1.334 1.033.466.234.766.734.766 1.234 0 .766-.633 1.366-1.366 1.366h-3.7.033ZM4.967 9.3H4.8c-.567.1-.967.567-.9 1.067 0 .2-.1.433-.3.466a.53.53 0 0 0-.4.5c0 .234.233.534.533.534h3.7c.3 0 .534-.234.534-.534 0-.3-.167-.466-.434-.533a.396.396 0 0 1-.333-.4c0-.3-.233-.533-.533-.533-.3 0-.167 0-.234.066-.066 0-.133.034-.2.034-.166 0-.3-.067-.366-.2-.167-.3-.5-.467-.9-.467ZM7.533 7.167a.441.441 0 0 1-.433-.434v-.266c0-.234.2-.434.433-.434.234 0 .434.2.434.434v.266c0 .234-.2.434-.434.434ZM5.8 7.766c-.1 0-.234-.033-.3-.133l-.2-.2a.496.496 0 0 1-.133-.3c0-.1.033-.233.133-.3a.496.496 0 0 1 .3-.133c.1 0 .233.033.3.133l.2.2c.067.067.133.2.133.3 0 .1-.033.233-.133.3a.496.496 0 0 1-.3.133ZM10.033 9.466a.441.441 0 0 1-.433-.433c0-.233.2-.433.433-.433h.267c.233 0 .433.2.433.433 0 .233-.2.433-.433.433h-.267ZM9.2 7.8c-.1 0-.233-.033-.3-.133a.496.496 0 0 1-.133-.3c0-.1.033-.234.133-.3l.2-.2a.496.496 0 0 1 .3-.134c.1 0 .233.034.3.134.067.066.133.2.133.3 0 .1-.033.233-.133.3l-.2.2a.496.496 0 0 1-.3.133ZM8.933 10.233a1.908 1.908 0 0 0-.533-.5c0-.066-.033-.133-.1-.233v-.233c0-.5-.4-.9-.933-.9-.534 0-.367.066-.5.166H6.5A1.868 1.868 0 0 0 6 8.2l.067-.1a1.74 1.74 0 0 1 1.3-.567c.966 0 1.766.8 1.766 1.767 0 .966-.066.533-.2.8l-.066.133h.066Z"
		/>
		<path
			fill="#1E1E1E"
			fillRule="evenodd"
			d="M1 14.6c-.567 0-1-.433-1-1V5.333c0-.566.433-1 1-1h1.933V2.467c0-.567.434-1 1-1H15c.567 0 1 .433 1 1v8.267c0 .566-.433 1-1 1h-1.933V13.6c0 .567-.434 1-1 1H1Zm11.067-1V5.333H1V13.6h11.067ZM15 10.733V2.467H3.933v1.866h8.134c.566 0 1 .434 1 1v5.4H15Z"
			clipRule="evenodd"
		/>
	</svg>
);

export const WeatherDataByIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
	>
		<path
			fill="#1E1E1E"
			d="m13.69 11.449-2.096-1.045a.569.569 0 0 0-.766.258.547.547 0 0 0-.053.257c0 .208.11.408.311.508l1.646.82-5.138 2.58-5.13-2.577 1.656-.79a.572.572 0 0 0 .322-.52.57.57 0 0 0-.816-.512l-2.14 1.024a.888.888 0 0 0-.486.806c0 .34.193.64.49.783l5.707 2.866c.125.06.261.093.393.093a.904.904 0 0 0 .401-.097l5.696-2.858a.894.894 0 0 0 .007-1.596h-.003Z"
		/>
		<path
			fill="#1E1E1E"
			d="M7.59 12.816c.433 0 .841-.186 1.128-.512.347-.397.75-.87 1.162-1.388 1.406-1.767 2.948-4.068 2.948-5.682A5.239 5.239 0 0 0 7.594 0a5.248 5.248 0 0 0-5.241 5.238c0 2.887 1.549 3.932 2.962 5.7.408.511.805.98 1.148 1.37.287.325.698.511 1.127.511v-.003Zm0-11.671a4.097 4.097 0 0 1 4.094 4.093c0 2.258-1.432 3.596-3.825 6.315a.347.347 0 0 1-.269.121.347.347 0 0 1-.268-.121C4.93 8.83 3.497 6.469 3.497 5.238A4.097 4.097 0 0 1 7.59 1.145Z"
		/>
		<path
			fill="#1E1E1E"
			d="M9.877 4.662H9.84a2.368 2.368 0 0 0-.25-.616l.02-.021a.586.586 0 0 0 0-.812.586.586 0 0 0-.811 0l-.022.021a2.42 2.42 0 0 0-.615-.25v-.036a.572.572 0 1 0-1.145 0v.036a2.367 2.367 0 0 0-.615.25l-.022-.021a.586.586 0 0 0-.812 0 .586.586 0 0 0 0 .812l.021.021a2.42 2.42 0 0 0-.25.616h-.036a.572.572 0 1 0 0 1.145h.036c.046.229.136.433.25.615l-.021.021a.586.586 0 0 0 0 .813.577.577 0 0 0 .411.171c.15 0 .287-.057.401-.171l.022-.022c.193.115.4.204.615.261v.022c0 .318.25.572.572.572.322 0 .573-.25.573-.572v-.022c.218-.057.422-.15.615-.26l.022.02a.571.571 0 0 0 .4.172c.14 0 .297-.057.412-.171a.586.586 0 0 0 0-.813l-.022-.021c.115-.182.194-.4.25-.615h.037c.318 0 .572-.25.572-.573a.565.565 0 0 0-.572-.572ZM7.59 6.604c-.755 0-1.37-.615-1.37-1.37 0-.755.615-1.37 1.37-1.37.755 0 1.37.615 1.37 1.37 0 .755-.615 1.37-1.37 1.37Z"
		/>
	</svg>
);

export const MeasurementUnitsIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
	>
		<g fill="#1E1E1E" clipPath="url(#a)">
			<path d="M8.035 4.624a5.3 5.3 0 0 0-5.333 5.332 5.3 5.3 0 0 0 5.333 5.333 5.3 5.3 0 0 0 5.332-5.333 5.3 5.3 0 0 0-5.332-5.332Zm0 9.585a4.235 4.235 0 0 1-4.253-4.253 4.235 4.235 0 0 1 4.253-4.252 4.235 4.235 0 0 1 4.252 4.252 4.235 4.235 0 0 1-4.252 4.253Z" />
			<path d="m10.735 8.336-2.227.473a1.49 1.49 0 0 0-1.08 0c-.608.337-.878 1.147-.54 1.755.337.607 1.147.877 1.755.54.337-.203.607-.54.675-.878l1.62-1.552s.067-.068 0-.203c-.034-.067-.102-.168-.203-.135Z" />
			<path d="M1.757 8.708c-.135 0-.303-.102-.54-.27l-.202-.135L.914 8.2C.44 7.695.137 7.358.002 5.906-.065 4.22 1.285 2.7 3.074 2.498c.168 0 .37-.102.405-.27C4.052.878 5.436 0 6.955 0S8.609.27 9.25.776c.101.102.27.102.337.102h.203c1.08 0 2.093.506 2.768 1.383.067.068.168.169.303.169l.135.068C14.717 2.633 16 4.084 16 5.906c0 1.823-.371 1.924-1.046 2.565-.102.102-.237.135-.405.135a.578.578 0 0 1-.574-.438v-.203c0-.067 0-.202.203-.371l.134-.135h.034c.371-.338.473-.574.574-1.586a1.778 1.778 0 0 0-.473-1.452c-.438-.506-1.113-.776-1.788-.776h-.203a.653.653 0 0 1-.573-.337c-.44-.777-1.215-1.283-2.06-1.283h-.472c-.202 0-.439-.067-.54-.169a2.751 2.751 0 0 0-1.856-.742c-.675 0-1.35.27-1.924.742-.506.338-.675 1.114-.709 1.283-.067.304-.37.472-.64.472h-.203c-1.283 0-2.262.979-2.262 2.262 0 1.282.27 1.248.777 1.687.168.169.37.371.303.641-.1.338-.37.574-.573.574l.033-.067ZM9.588 12.049H6.55c-.236 0-.405.169-.405.371 0 .203.169.371.405.371h3.038c.236 0 .405-.168.405-.37 0-.203-.17-.372-.405-.372Z" />
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h16v16H0z" />
			</clipPath>
		</defs>
	</svg>
);

export const AdditionalDataGeneralIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
	>
		<path
			fill="#1E1E1E"
			d="M12.5 10.833c-.233-.066-.367-.3-.367-.533 0-.233.267-.567.567-.567h.567c.8 0 1.466-.666 1.466-1.466 0-.8-.666-1.467-1.466-1.467-.8 0-.567-.233-.567-.533A2.172 2.172 0 0 0 10.5 4.2c-1.2 0-.9.133-1.3.4-.1.067-.233.1-.333.1h-.1a.48.48 0 0 1-.367-.3C8 3.533 7.1 3 6.134 3c-1.4 0-2.5 1.1-2.5 2.5s0 .433.1.633a.558.558 0 0 1-.134.5c-.1.1-.266.167-.4.167h-.4c-.8 0-1.466.667-1.466 1.467S2 9.733 2.8 9.733h.567c.3 0 .567.267.567.567 0 .3-.267.567-.567.567H2.8a2.603 2.603 0 0 1-2.6-2.6c0-1.434.9-2.334 2.167-2.567h.167v-.2c0-2 1.633-3.6 3.6-3.6 1.966 0 2.133.5 2.833 1.367l.1.133.133-.067c.467-.166.9-.266 1.3-.266A3.352 3.352 0 0 1 13.733 5.6v.133h.167c1.133.267 1.967 1.3 2 2.5 0 1.434-1.167 2.567-2.6 2.567h-.767l-.033.033Z"
		/>
		<path
			fill="#1E1E1E"
			d="M9.767 14.133a.526.526 0 0 1-.533-.533v-2.2c-.534-.234-.834-.734-.834-1.3 0-.567.3-1.067.834-1.3v-.467c0-.3.233-.533.533-.533.3 0 .533.233.533.533v.433c.5.234.834.734.834 1.3 0 .567-.334 1.067-.834 1.3v2.2c0 .3-.233.534-.533.534v.033ZM6.267 14.133a.526.526 0 0 1-.533-.533v-.433c-.534-.233-.834-.733-.834-1.3 0-.567.3-1.067.834-1.3v-2.2c0-.3.233-.534.533-.534.3 0 .533.234.533.534v2.2c.5.233.834.733.834 1.3 0 .566-.334 1.066-.834 1.3v.466c0 .3-.233.534-.533.534v-.034Z"
		/>
	</svg>
);

export const ControlLayerIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
	>
		<g clipPath="url(#a)">
			<path
				fill="#000"
				d="M15.55 7.947v-.01c0-.57-.316-1.068-.782-1.328l-.007-.004-.534-.297.534-.297a1.535 1.535 0 0 0 .007-2.68l-.007-.004L9.399.333A2.635 2.635 0 0 0 8.107 0c-.475 0-.92.123-1.306.34l.014-.007-5.36 2.994a1.535 1.535 0 0 0-.007 2.68l.007.004.534.297-.534.297a1.535 1.535 0 0 0-.007 2.68l.007.004.534.298-.534.297a1.535 1.535 0 0 0-.007 2.68l.007.005 5.361 2.993c.372.21.818.334 1.292.334.474 0 .92-.124 1.305-.34l-.013.006.067-.037a.622.622 0 1 0-.608-1.083l.002-.001-.066.036a1.411 1.411 0 0 1-1.38-.004l.007.004-5.36-2.993a.294.294 0 0 1-.002-.514l.001-.001 1.2-.671 3.555 1.985c.372.21.818.334 1.292.334.474 0 .92-.124 1.305-.341l-.013.007 3.555-1.985 1.2.67a.294.294 0 0 1 .001.515l-.001.001-2.584 1.443a.622.622 0 1 0 .608 1.083l-.002.001 2.584-1.442a1.536 1.536 0 0 0 .007-2.68l-.007-.004-.534-.298.534-.297c.473-.263.788-.761.788-1.332v-.011ZM1.908 4.667v-.005c0-.11.06-.204.15-.252h.002l5.36-2.994a1.41 1.41 0 0 1 1.38.004l-.007-.004 5.36 2.993a.294.294 0 0 1 .002.515h-.001L8.794 7.919a1.41 1.41 0 0 1-1.38-.004l.007.004-5.36-2.991a.286.286 0 0 1-.152-.26ZM14.155 8.2l-5.36 3a1.411 1.411 0 0 1-1.38-.004l.007.004-5.36-2.993a.294.294 0 0 1-.002-.515h.001l1.2-.671 3.555 1.984c.372.21.818.334 1.292.334.474 0 .92-.123 1.305-.34l-.013.006 3.555-1.984 1.2.67a.294.294 0 0 1 .001.515h-.001V8.2Z"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h16v16H0z" />
			</clipPath>
		</defs>
	</svg>
);

export const MapPreferenceIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 15 }
		height={ 16 }
		fill="none"
	>
		<g clipPath="url(#a)">
			<mask
				id="b"
				width={ 15 }
				height={ 16 }
				x={ 0 }
				y={ 0 }
				maskUnits="userSpaceOnUse"
				style={ {
					maskType: 'luminance',
				} }
			>
				<path fill="#fff" d="M15 .5H0v15h15V.5Z" />
			</mask>
			<g fill="#000" mask="url(#b)">
				<path d="m3.945 9.71.09.03c-.03-.075-.045-.135-.06-.195s-.03-.105-.045-.165v-.03a4.79 4.79 0 0 1-.18-.945c-.585-.285-.96-.93-.96-1.65 0-.45.195-.945.525-1.26.255-.255.555-.42.9-.48l.435-.09v-.42C4.755 3.17 5.925 2.12 7.305 2.12c1.125 0 2.115.675 2.505 1.74v.015l.15.315.315.075h.015c1.095.165 1.935 1.11 1.935 2.205v.105a2.254 2.254 0 0 1-.765 1.53c0 .075-.015.165-.015.255-.03.36-.105.72-.21 1.065-.03.075-.045.15-.075.225a3.398 3.398 0 0 0 2.235-2.865v-.3c0-1.56-1.065-2.91-2.58-3.3A3.96 3.96 0 0 0 7.29.95c-1.815 0-3.42 1.305-3.765 3.045-.39.135-.78.39-1.065.66-.585.57-.93 1.38-.93 2.16.015 1.365 1.02 2.58 2.415 2.895ZM14.535 14.12 13.5 10.715a.72.72 0 0 0-.69-.54h-1.875c-.03.06-.045.12-.075.18-.15.3-.3.6-.48.87-.03.06-.075.12-.12.18h2.16l.75 2.415H1.86l.75-2.415h2.265a9.558 9.558 0 0 1-.66-1.23H2.25a.724.724 0 0 0-.69.525L.45 14.12c-.06.18-.03.39.06.6l.03.03.015.015c.09.09.315.285.585.285h12.69a.7.7 0 0 0 .6-.3c.15-.15.195-.375.105-.63Z" />
				<path d="M7.515 4.655c-1.86 0-3.375 1.44-3.375 3.195 0 2.55 2.145 4.77 2.97 5.415l.015.015.015.015c.12.06.27.135.42.135.165 0 .3-.075.435-.135l.015-.015.015-.015c.69-.6 2.955-2.79 2.955-5.43-.105-1.77-1.635-3.18-3.465-3.18Zm0 1.29c1.155 0 2.145.9 2.145 1.965 0 1.59-1.14 3.12-2.145 4.155C6.51 11.03 5.37 9.515 5.37 7.91c.015-1.095.96-1.965 2.145-1.965Z" />
				<path d="M7.53 6.755c-.75 0-1.395.63-1.395 1.395 0 .75.63 1.395 1.395 1.395.75 0 1.395-.63 1.395-1.395-.075-.765-.645-1.395-1.395-1.395Z" />
			</g>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 .5h15v15H0z" />
			</clipPath>
		</defs>
	</svg>
);

export const PopupWeatherDataIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
	>
		<path
			fill="#000"
			d="M8 15.3c-.333 0-.667-.133-.933-.4L5.8 13.633H3.533a3.272 3.272 0 0 1-3.266-3.266v-6.4C.267 2.167 1.733.7 3.533.7h8.934c1.8 0 3.266 1.467 3.266 3.267V10.3c0 1.8-1.466 3.267-3.266 3.267H10.2l-1.267 1.267c-.266.333-.6.466-.933.466ZM3.533 2.167c-1 0-1.8.8-1.8 1.8V10.3c0 1 .8 1.8 1.8 1.8H6c.267 0 .533.133.733.267L8.067 13.7 9.4 12.367c.2-.2.467-.334.733-.334h2.4c1 0 1.8-.8 1.8-1.8V3.967c0-1-.8-1.8-1.8-1.8h-9Z"
		/>
		<path
			fill="#000"
			d="M11.2 5.234H7.333a.668.668 0 0 1-.666-.667c0-.333.266-.667.666-.667h3.8c.334 0 .667.267.667.667s-.267.667-.6.667ZM11.2 7.767H7.333a.668.668 0 0 1-.666-.667c0-.333.266-.666.666-.666h3.8c.334 0 .667.266.667.666s-.267.667-.6.667ZM11.2 10.3H7.333a.668.668 0 0 1-.666-.667c0-.333.266-.666.666-.666h3.8c.334 0 .667.266.667.666s-.267.667-.6.667ZM4.8 5.234a.668.668 0 0 1-.667-.667c0-.333.267-.667.667-.667.333 0 .667.267.667.667s-.267.667-.667.667ZM4.8 7.767a.668.668 0 0 1-.667-.667c0-.333.267-.666.667-.666.333 0 .667.266.667.666s-.267.667-.667.667ZM4.8 10.3a.668.668 0 0 1-.667-.667c0-.333.267-.666.667-.666.333 0 .667.266.667.666S5.2 10.3 4.8 10.3Z"
		/>
	</svg>
);

export const TabsIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
	>
		<g clipPath="">
			<path
				fill="#232323"
				d="M3.177 15.178a2.64 2.64 0 0 1-1.825-.781 2.623 2.623 0 0 1-.778-1.872V3.469c0-.71.275-1.372.778-1.872.5-.5 1.166-.778 1.872-.778h9.547c.71 0 1.372.275 1.872.778a2.65 2.65 0 0 1 .778 1.872v9.06c0 .709-.275 1.371-.778 1.871a2.66 2.66 0 0 1-1.872.778H3.177Zm0-13.169a1.45 1.45 0 0 0-.984.425 1.45 1.45 0 0 0-.428 1.032v9.059a1.46 1.46 0 0 0 1.46 1.46h9.546c.39 0 .756-.154 1.031-.429a1.45 1.45 0 0 0 .428-1.031V6.153H9.462a2.532 2.532 0 0 1-1.8-.747 2.527 2.527 0 0 1-.747-1.8V2.01H3.177ZM8.11 3.66c.012.344.153.666.396.913.257.256.597.397.96.397h4.769V3.472c0-.39-.153-.756-.428-1.031a1.45 1.45 0 0 0-1.032-.429H8.11V3.66Z"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h16v16H0z" />
			</clipPath>
		</defs>
	</svg>
);
export const TableIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
	>
		<g clipPath="">
			<path
				fill="#1E1E1E"
				d="M12.822.656H3.178A2.619 2.619 0 0 0 .563 3.272v9.197a2.619 2.619 0 0 0 2.615 2.615h9.647a2.619 2.619 0 0 0 2.616-2.615V3.272A2.619 2.619 0 0 0 12.825.656h-.003ZM3.178 1.844h9.647c.788 0 1.428.64 1.428 1.428v.697H1.75v-.697c0-.788.64-1.428 1.428-1.428Zm4.228 6.619v2.121H1.75V8.463h5.656ZM1.75 7.275V5.153h5.656v2.122H1.75Zm6.844 1.188h5.656v2.121H8.594V8.463Zm0-1.188V5.153h5.656v2.122H8.594ZM1.75 12.469v-.697h5.656v2.122H3.178a1.43 1.43 0 0 1-1.428-1.428v.003Zm11.072 1.425H8.594v-2.122h5.656v.697a1.43 1.43 0 0 1-1.428 1.428v-.003Z"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h16v16H0z" />
			</clipPath>
		</defs>
	</svg>
);

export const AdvanceSettingIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
	>
		<g clipPath="url(#a)">
			<path
				fill="#1E1E1E"
				d="M14.213 9.325a3.435 3.435 0 0 0-2.444-1.012c-.922 0-.55.034-.816.1l-.703-.704 2.069-2.068.194.193a.55.55 0 0 0 .39.16c.147 0 .375-.1.472-.269l1.76-2.931a.553.553 0 0 0-.085-.675L13.878.947a.55.55 0 0 0-.39-.16.46.46 0 0 0-.285.079l-2.93 1.76a.555.555 0 0 0-.11.865l.193.193-2.068 2.07-.703-.704a3.472 3.472 0 0 0-.913-3.26 3.399 3.399 0 0 0-2.419-1c-.915 0-1.147.144-1.65.416a.552.552 0 0 0-.128.878l1.556 1.557c.05.053.082.122.082.193a.267.267 0 0 1-.082.194.286.286 0 0 1-.193.081.267.267 0 0 1-.194-.08L2.088 2.471a.559.559 0 0 0-.39-.16c-.148 0-.054 0-.08.007a.552.552 0 0 0-.405.284A3.478 3.478 0 0 0 .825 4.71c.1.754.435 1.432.972 1.97A3.435 3.435 0 0 0 4.241 7.69c.922 0 .55-.035.815-.1l.116.115-3.731 3.735a2.21 2.21 0 0 0 0 3.125c.415.415.972.643 1.562.643.59 0 1.147-.23 1.563-.643l3.731-3.732.116.116a3.464 3.464 0 0 0 .912 3.26 3.402 3.402 0 0 0 2.422 1.003c.916 0 1.147-.144 1.65-.416a.552.552 0 0 0 .128-.878l-1.556-1.556a.286.286 0 0 1-.081-.194c0-.072.028-.144.08-.194a.267.267 0 0 1 .195-.081c.072 0 .143.028.193.081l1.557 1.556c.053.05.112.094.18.122a.54.54 0 0 0 .213.044c.075 0 .054 0 .079-.006a.552.552 0 0 0 .406-.285c.344-.64.481-1.387.387-2.103a3.404 3.404 0 0 0-.972-1.969l.007-.006v-.003Zm-.05 3.075-1.113-1.112a1.247 1.247 0 0 0-1.76 0 1.247 1.247 0 0 0 0 1.759l1.113 1.112c-.843.232-1.756 0-2.393-.634a2.504 2.504 0 0 1-.585-2.594.409.409 0 0 0-.1-.43L5.5 6.674a.417.417 0 0 0-.431-.1 2.496 2.496 0 0 1-2.594-.584 2.448 2.448 0 0 1-.634-2.394l1.112 1.112a1.247 1.247 0 0 0 1.76 0 1.247 1.247 0 0 0 0-1.759L3.6 1.838c.844-.232 1.756 0 2.394.634.675.675.903 1.694.584 2.594a.409.409 0 0 0 .1.431l3.825 3.825a.417.417 0 0 0 .432.1 2.496 2.496 0 0 1 2.593.584c.64.641.866 1.547.635 2.394Zm-12.04 1.481a1.241 1.241 0 0 1 0-1.759L5.95 8.294l1.76 1.76L3.88 13.88a1.247 1.247 0 0 1-1.759 0Zm9.024-9.609.588.587-2.263 2.263-.587-.588 2.262-2.262Zm.081-1.09 2.197-1.32.716.716-1.319 2.197-1.594-1.594Z"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h16v16H0z" />
			</clipPath>
		</defs>
	</svg>
);

export const AccordionPreferenceIcon = () => (
	<svg
		width={ 16 }
		height={ 16 }
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_11161_6456)">
			<path
				d="M3.47227 16C1.83789 16 0.509766 14.7594 0.509766 13.2375V2.7625C0.509766 1.24063 1.84102 0 3.47227 0H12.5254C14.1598 0 15.4879 1.24063 15.4879 2.7625V13.2344C15.4879 14.7594 14.1598 15.9969 12.5254 15.9969H3.47227V16ZM3.47227 1.09375C2.49727 1.09375 1.70352 1.84375 1.70352 2.76562V13.2375C1.70352 14.1594 2.49727 14.9094 3.47227 14.9094H12.5254C13.5004 14.9094 14.2941 14.1594 14.2941 13.2375V2.7625C14.2941 1.84063 13.5004 1.09063 12.5254 1.09063H3.47227V1.09375Z"
				fill="#1E1E1E"
			/>
			<path
				d="M4.13398 12.9873C3.80586 12.9873 3.53711 12.7436 3.53711 12.4404C3.53711 12.1373 3.80586 11.8936 4.13398 11.8936H11.8684C12.1965 11.8936 12.4652 12.1373 12.4652 12.4404C12.4652 12.7436 12.1965 12.9873 11.8684 12.9873H4.13398Z"
				fill="#1E1E1E"
			/>
		</g>
		<defs>
			<clipPath id="clip0_11161_6456">
				<rect width={ 16 } height={ 16 } fill="white" />
			</clipPath>
		</defs>
	</svg>
);
export const AqiSummaryIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
		viewBox="0 0 16 16"
	>
		<path
			fill="#2F2F2F"
			d="M7.875 6.8c-.3 0-.55-.25-.55-.55 0-.3.25-.55.55-.55h1.85c.125 0 .2-.1.2-.2s-.1-.2-.2-.2h-.5c-.3 0-.55-.25-.55-.55 0-.3.25-.55.55-.55h.5c.725 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3h-1.85ZM6 9.925c-.175 0-.35-.1-.45-.225-.175-.25-.1-.6.125-.775.025 0 .05-.05.05-.1S5.675 8.7 5.6 8.7h-.75c-.3 0-.55-.25-.55-.55 0-.3.25-.55.55-.55h.75c.675 0 1.225.55 1.225 1.225s-.2.775-.525 1c-.1.075-.2.1-.325.1H6ZM5.75 4.825c-.3 0-.55-.25-.55-.55 0-.3.25-.55.55-.55h1.225c.125 0 .225-.1.225-.225 0-.3.25-.55.55-.55.3 0 .55.25.55.55 0 .725-.6 1.325-1.325 1.325H5.75Z"
		/>
		<path
			fill="#2F2F2F"
			d="M7.525 12.475H7.4c-1.025.175-2.425 0-3.5-1.575C1.825 10.875.675 9.175.675 7.1c0-2.075 1.175-3.225 2.8-3.675A3.81 3.81 0 0 1 7.225.3c1.85 0 2.175.475 2.9 1.325.2-.05.4-.075.6-.075 1.275 0 2.3 1.025 2.3 2.3 1.225.75 2 2.075 2 3.5 0 1.425-.15 1.3-.475 1.875a.56.56 0 0 1-.475.3c-.2 0-.175 0-.25-.075a.591.591 0 0 1-.275-.325.504.504 0 0 1 .05-.425c.225-.425.35-.9.35-1.375 0-1.15-.675-2.2-1.725-2.675a.538.538 0 0 1-.3-.6v-.225c0-.65-.55-1.2-1.2-1.2-.65 0-.375.05-.55.125a.482.482 0 0 1-.25.075c-.175 0-.35-.1-.45-.25A2.706 2.706 0 0 0 4.525 3.9c0 .25-.225.475-.475.5-1.3.2-2.3 1.35-2.3 2.675 0 1.325.7 2.7 2.2 2.7h.25c.225 0 .4.125.5.325.6 1.3 2.075 1.525 2.925 1.275.85-.25.275.125.35.25.075.125.1.275.075.425a.535.535 0 0 1-.525.425Z"
		/>
		<path
			fill="#2F2F2F"
			d="M11.375 15.675A3.916 3.916 0 0 1 7.45 11.75a3.916 3.916 0 0 1 3.925-3.925A3.916 3.916 0 0 1 15.3 11.75a3.916 3.916 0 0 1-3.925 3.925Zm0-6.75A2.838 2.838 0 0 0 8.55 11.75a2.838 2.838 0 0 0 2.825 2.825A2.838 2.838 0 0 0 14.2 11.75a2.838 2.838 0 0 0-2.825-2.825Z"
		/>
		<path
			fill="#2F2F2F"
			d="M11.025 13.475a.48.48 0 0 1-.4-.225l-.925-1.2c-.175-.25-.15-.575.1-.775a.588.588 0 0 1 .325-.125c.175 0 .325.075.425.225l.55.7 1.5-1.5c.1-.1.25-.175.4-.175.15 0 .275.05.375.15a.53.53 0 0 1 0 .775l-1.925 1.95a.59.59 0 0 1-.4.175h-.025v.025Z"
		/>
	</svg>
);
export const AqiPollutantIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
		viewBox="0 0 16 16"
	>
		<path
			fill="#2F2F2F"
			d="M14.438 2.875a1.438 1.438 0 1 0 0-2.875 1.438 1.438 0 0 0 0 2.875Zm0-1a.438.438 0 1 1 0-.875.438.438 0 0 1 0 .875Zm-4.633 12.19c1.65 0 3.02-1.191 3.302-2.76C14.677 11.025 15.9 9.659 15.9 8c0-1.413-.899-2.588-2.106-3.087a3.341 3.341 0 0 0-3.087-2.075c-.659 0-1.268.193-1.782.52a3.332 3.332 0 0 0-2.73-1.422 3.358 3.358 0 0 0-3.304 2.761C1.32 4.978.1 6.342.1 8c0 1.412.897 2.589 2.104 3.088a3.343 3.343 0 0 0 3.089 2.074c.658 0 1.267-.192 1.781-.518a3.334 3.334 0 0 0 2.73 1.421Zm0-1.3c-.881 0-1.63-.56-1.922-1.35a.65.65 0 0 0-1.087-.217c-.38.41-.911.664-1.503.664a2.05 2.05 0 0 1-1.959-1.468.65.65 0 0 0-.436-.435C2.035 9.699 1.4 8.912 1.4 8c0-1.127.942-2.057 2.087-2.058a.65.65 0 0 0 .65-.649c0-1.136.922-2.058 2.058-2.058.881 0 1.63.56 1.922 1.35l.034.077a.651.651 0 0 0 1.053.14c.38-.41.912-.664 1.503-.664a2.05 2.05 0 0 1 1.959 1.468l.028.077a.652.652 0 0 0 .408.359C13.965 6.302 14.6 7.088 14.6 8c0 1.127-.942 2.057-2.087 2.058a.65.65 0 0 0-.65.65 2.057 2.057 0 0 1-2.058 2.057Zm-8.318 3.11a1.438 1.438 0 1 0 0-2.875 1.438 1.438 0 0 0 0 2.875Zm0-1a.438.438 0 1 1 0-.875.438.438 0 0 1 0 .875Z"
		/>
	</svg>
);
export const AqiPollutantPopupIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		viewBox="0 0 16 16"
		fill="none"
	>
		<path
			fill="#2F2F2F"
			d="M9.15 15.738a.65.65 0 0 0 .65-.65V12.8h5.288a.65.65 0 0 0 .65-.65V.9a.65.65 0 0 0-.65-.651H3.838a.65.65 0 0 0-.65.65v5.287H.9a.65.65 0 0 0-.65.65v8.25c0 .36.291.651.65.651h8.25Zm-4.658-8.9c0-.013-.003-.025-.004-.037V1.55h9.95V11.5H4.492V6.838Zm-2.941.65h1.637v4.662c0 .187.079.354.205.473a.647.647 0 0 0 .449.182H8.5v1.633H1.55v-6.95Z"
		/>
		<path
			fill="#2F2F2F"
			d="M12.405 3.938a.469.469 0 1 0 0-.938.469.469 0 0 0 0 .938ZM10.308 9.6c.84 0 1.544-.58 1.738-1.362A1.8 1.8 0 0 0 13.423 6.5c0-.732-.45-1.341-1.059-1.621a1.784 1.784 0 0 0-1.62-1.043c-.296 0-.572.075-.815.201A1.776 1.776 0 0 0 8.565 3.4c-.841 0-1.546.58-1.739 1.362A1.8 1.8 0 0 0 5.45 6.5c0 .732.449 1.342 1.058 1.622A1.786 1.786 0 0 0 8.13 9.165c.295 0 .57-.074.813-.2.327.387.815.636 1.365.636Zm0-.973a.818.818 0 0 1-.767-.54.486.486 0 0 0-.812-.161.813.813 0 0 1-.6.265.818.818 0 0 1-.78-.586.487.487 0 0 0-.326-.326.83.83 0 0 1-.6-.78c0-.446.375-.82.835-.82a.487.487 0 0 0 .486-.487.818.818 0 0 1 1.588-.282l.025.058a.486.486 0 0 0 .788.104.814.814 0 0 1 .598-.265c.366 0 .678.244.781.587l.05.109c.06.102.158.18.276.216.35.105.6.422.6.78a.834.834 0 0 1-.835.821.487.487 0 0 0-.486.487c0 .453-.368.82-.821.82Zm-3.903 1.31a.469.469 0 1 0 0-.938.469.469 0 0 0 0 .938Z"
		/>
	</svg>
);
export const AqiForecastIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		viewBox="0 0 16 16"
		fill="none"
	>
		<path
			fill="#2F2F2F"
			d="M0 9.306c0-1.404.565-2.257.945-2.712a3.337 3.337 0 0 1 3.317-3.698 3.3 3.3 0 0 1 1.771.512A3.312 3.312 0 0 1 8.74 2c1.317 0 2.438.766 2.98 1.864 1.008.138 1.97.53 2.7 1.34.825.912 1.27 2.261 1.27 4.102a.65.65 0 0 1-1.3 0c0-1.644-.397-2.637-.934-3.232-.534-.592-1.296-.887-2.231-.956a.65.65 0 0 1-.568-.437A2.029 2.029 0 0 0 8.74 3.3a2.02 2.02 0 0 0-1.705.944l-.07.117v.001s0 .004-.002.006l-.01.02-.042.072-.133.242a.651.651 0 0 1-1.04.134 2.024 2.024 0 0 0-1.475-.64 2.037 2.037 0 0 0-1.99 2.461.651.651 0 0 1-.159.576c-.253.275-.813.86-.813 2.073a.65.65 0 0 1-1.301 0ZM14.875 2.438a.438.438 0 1 1-.875 0 .438.438 0 0 1 .875 0Zm1 0a1.438 1.438 0 1 0-2.875 0 1.438 1.438 0 0 0 2.875 0ZM2.075 1.638a.438.438 0 1 1-.875 0 .438.438 0 0 1 .875 0Zm1 0a1.438 1.438 0 1 0-2.875 0 1.438 1.438 0 0 0 2.875 0Z"
		/>
		<path
			fill="#2F2F2F"
			d="M5.47 9.161c.47-.75 1.593-.737 2.043.026l.086.173 1.88 4.702.744-1.983.078-.168a1.2 1.2 0 0 1 1.046-.611H14.5a.7.7 0 0 1 .14 1.386l-.14.014h-3.015l-.877 2.337c-.384 1.026-1.83 1.042-2.237.025l-1.893-4.734-.705 1.645c-.189.44-.623.727-1.103.727H1.5a.7.7 0 0 1 0-1.4h3.038l.843-1.966.09-.173ZM6.3 1.65a.65.65 0 1 1-1.3 0 .65.65 0 0 1 1.3 0ZM10.3 5.65a.65.65 0 1 1-1.3 0 .65.65 0 0 1 1.3 0ZM13.3 7.65a.65.65 0 1 1-1.3 0 .65.65 0 0 1 1.3 0Z"
		/>
		<path
			fill="#2F2F2F"
			d="M10.3 9.65a.65.65 0 1 1-1.3 0 .65.65 0 0 1 1.3 0ZM6.3 6.65a.65.65 0 1 1-1.3 0 .65.65 0 0 1 1.3 0ZM4.3 8.65a.65.65 0 1 1-1.3 0 .65.65 0 0 1 1.3 0Z"
		/>
	</svg>
);

export const WeatherApiKeyIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
	>
		<g fill="#2F2F2F" clipPath="">
			<path d="M6.099 11.83c0 .697-.566 1.264-1.263 1.264a1.264 1.264 0 0 1-1.263-1.263c0-.696.567-1.263 1.263-1.263S6.1 11.135 6.1 11.83Z" />
			<path d="M14.544 11.356a.492.492 0 1 0 0-.983H7.329a2.664 2.664 0 0 0-2.493-1.704c-1.018 0-1.94.58-2.39 1.473a1.71 1.71 0 0 0-1.509 1.695c0 .875.661 1.594 1.51 1.694a2.683 2.683 0 0 0 2.389 1.475 2.664 2.664 0 0 0 2.493-1.703H10v.906h2.4v-.906h.8v.906h1.345c.265 0 .492-.172.492-.45 0-.275-.224-.468-.492-.468H14v-.972h-2.4v.972h-.8v-.972H6.675l-.008.04-.028.151-.04.148c-.13.569-.622 1.05-1.157 1.254l-.11.038a1.7 1.7 0 0 1-2.096-1.06l-.104-.294-.012-.033h-.432c-.394 0-.728-.288-.764-.652a.726.726 0 0 1 .72-.798h.476l.012-.033.08-.232.05-.123c.26-.596.813-1.022 1.447-1.067.803-.058 1.6.433 1.849 1.166l.042.15.038.188.029.154.008.04h7.869Z" />
			<path d="m3.304 6.347.09.054c.236.11.535.058.71-.164a.553.553 0 0 0-.094-.775 2.468 2.468 0 0 0-.34-.225c.341-1.815 1.737-3.086 3.335-3.086 1.424 0 2.736 1.029 3.226 2.624l.174.568.039.122.055-.034.054-.035.228-.142.252-.159.113-.061a.814.814 0 0 1 .33-.07c.257 0 .51.134.691.372-.637.422-1.084 1.14-1.207 1.966l-.02.171a.543.543 0 0 0 .548.585.542.542 0 0 0 .546-.478l.023-.162c.142-.788.747-1.33 1.406-1.33.751 0 1.435.711 1.436 1.676 0 .145-.017.284-.047.416l-.036.132c-.11.358.18.688.533.688a.549.549 0 0 0 .532-.388c.057-.2.095-.414.11-.632L16 7.764c0-1.514-1.096-2.825-2.536-2.826-.076 0-.15.005-.223.013-.35-.672-1.007-1.137-1.764-1.137a1.83 1.83 0 0 0-.41.048C10.326 2.149 8.769 1 7.006 1 4.837 1 3.055 2.688 2.6 4.941h-.015a.884.884 0 0 0-.05-.003c-1.44 0-2.536 1.311-2.536 2.826 0 .296.045.59.121.857l.031.079c.094.19.294.3.498.3.353 0 .644-.33.533-.688a1.859 1.859 0 0 1-.082-.548c0-.965.684-1.676 1.435-1.676.267 0 .54.092.769.26Z" />
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h16v16H0z" />
			</clipPath>
		</defs>
	</svg>
);
